"use client";

import ChefsSpecial from "../components/chefs-special";
import { Footer } from "../components/footer";
import Hero from "../components/hero";
import { InstagramFeed } from "../components/instagram";

import { useAppSelector } from "@/store/hooks";
import { ContentLoader } from "@/ui";
import { AppDownloadBanner } from "@/ui/call-to-action";
import { useRouter, useSearchParams } from "next/navigation";

export default function HomeClient() {
  const route = useRouter();
  const searchParams = useSearchParams();

  // Get content from Redux store (populated by ContentInitializer)
  const {
    data: content,
    loading,
    error,
  } = useAppSelector((state) => state.content);

  const handleViewMenu = () => {
    console.log("Navigate to menu");
    const mode = searchParams.get("mode");
    const slug = searchParams.get("slug");
    const query = mode && slug ? `?mode=${mode}&slug=${slug}` : "";
    route.push(`/menu${query}`);
  };

  const handleMakeReservation = () => {
    console.log("Navigate to reservation");
  };

  if (loading) {
    return <ContentLoader message="Preparing your culinary experience..." />;
  }

  if (error) {
    return (
      <ContentLoader message="We're experiencing technical difficulties. Please refresh the page." />
    );
  }

  if (!content) {
    return (
      <ContentLoader message="One moment, we're crafting your experience..." />
    );
  }

  return (
    <main>
      <Hero
        onPrimaryClick={handleViewMenu}
        onSecondaryClick={handleMakeReservation}
      />
      <ChefsSpecial />
      <InstagramFeed />
      <AppDownloadBanner size="md" />
      <Footer />
    </main>
  );
}
